// Demo-bruker: KUN for frittstående UI-visning uten backend (VITE_SKADE_WS
// usatt). I live-modus kommer den innloggede brukeren fra hubbens /auth/me
// (signert sesjon), se auth/api.ts og docs/SKADE_BMS.md §5. En lagfører i HV-01 /
// Oslofjord sensorområde (Østfold+Vestfold) så RBAC-gatingen kan demonstreres.
import type { User } from '@skade/rbac';

export const demoUser: User = {
  id: '@demo-lagfører:skade',
  role: 'lagfører',
  org: { district: 'HV-01', area: 'Oslofjord', troop: 'Tropp 1', team: 'Lag 2' },
};

export function roleLabel(u: User): string {
  return `${u.role.toUpperCase()} · ${u.org.district}`;
}
